/// <reference path="../../node_modules/cb-dts-jssocials/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.colorbox/index.d.ts" />


module SeniorHelp.Franchise
{
    let contentArea: HTMLDivElement;
    let expandArea: HTMLDivElement;
    let mapImage: HTMLDivElement;
    let reviewMoreButton: HTMLAnchorElement;
    let reviewContainer: HTMLDivElement;

    export interface IFranchiseOptions
    {
        shareOptions: jsSocials.ShareName[];
    }

    function showAllAreas(ev: Event)
    {
        ev.preventDefault();
        contentArea.style.display = "none";
        expandArea.style.display = "flex";
        mapImage.style.opacity = "0";
    }

    function hideAllAreas(ev: Event)
    {
        ev.preventDefault();
        expandArea.style.display = "none";
        contentArea.style.display = "flex";
        mapImage.style.opacity = "1";
    }

    function fetchMoreReviews(ev: Event)
    {
        ev.preventDefault();

        const button = $(reviewMoreButton);

        $.ajax({
            url: `${button.data("url")}?to=${button.data("date")}`,
            method: "GET"
        }).done(loadMoreReviews)
    }

    function loadMoreReviews(data: any, _status: string, xhr: JQuery.jqXHR)
    {
        $(reviewContainer).append(data);
        $(reviewMoreButton).data("date", xhr.getResponseHeader("X-Next-Date"));

        if ($(reviewContainer).find(".franchise-review").length % 5 !== 0)
        {
            $(reviewMoreButton).addClass("collapse");
        }
    }

    export function Initialise(optionParams: IFranchiseOptions)
    {
        contentArea = document.getElementById("coverage-content") as HTMLDivElement;
        expandArea = document.getElementById("coverage-expand") as HTMLDivElement;
        mapImage = document.getElementById("coverage-map") as HTMLDivElement;
        reviewMoreButton = document.getElementById("reviews-modal-more") as HTMLAnchorElement;
        reviewContainer = document.getElementById("reviews-modal-container") as HTMLDivElement;

        if (reviewMoreButton != null)
        {
            reviewMoreButton.addEventListener("click", fetchMoreReviews);
        }

        const expandLinks = document.querySelectorAll("a[href='#coverage-expand']");
        for (let i = 0; i < expandLinks.length; i++)
        {
            expandLinks[i].addEventListener("click", showAllAreas);
        }

        const contentLinks = document.querySelectorAll("a[href='#coverage-content']");
        for (let i = 0; i < contentLinks.length; i++)
        {
            contentLinks[i].addEventListener("click", hideAllAreas);
        }

        $("#franchise-sharing")
            .jsSocials({
                showLabel: false,
                shares: optionParams.shareOptions
            });

        $("[rel=gallery]")
            .colorbox({
                maxWidth: "85%",
                maxHeight: "85%",
                previous: "<i class=\"la la-angle-left\"></i>",
                next: "<i class=\"la la-angle-right\"></i>",
                close: "<i class=\"la la-times\"></i>"
            });
    }
}